export default __webpack_public_path__ + "static/blue wave-00d6e7bf8688aee0e0e0379f6a637382.png";